export type EventsDataProps = {
  eventStartDate?: string
  eventEndDate?: string
}

export const validName = (name: string, min = 2, max = 32): boolean => {
  return /^[a-zA-Z0-9_ /]+$/.test(name) && name?.length >= min && name?.length <= max
}
export const validLabel = (label: string, min = 2, max = 32): boolean => {
  return /^[a-zA-Z0-9_ \-/()]+$/.test(label) && label?.length >= min && label?.length <= max
}
export const validText = (title: string, min = 2, max = 500): boolean => {
  return /^[a-zA-Z0-9_ ]+$/.test(title) && title?.length >= min && title?.length <= max
}
export const validTextWithSpecialChar = (title: string, min = 2, max = 500): boolean => {
  return (
    /^[a-zA-Z0-9_ !@#$%^&*()\[\]{};:'",.<>?\\|\/\-+=]+$/.test(title) &&
    title.length >= min &&
    title.length <= max
  )
}

export const validHexColorCode = (title: string): boolean => {
  return /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(title)
}

export const validateLink = (url: string): boolean => {
  return !url || /^(http|https|tel|mailto|intent):[^ "]+$/.test(url)
}

export const validateEnddate = (value: string, formValues: EventsDataProps) => {
  if (!formValues.eventStartDate) return 'Start date is required.'

  const startDate = new Date(formValues.eventStartDate).getTime()
  const endDate = new Date(value).getTime()

  if (endDate <= startDate) {
    return 'Event End Date must be after Start Date.'
  }

  return true
}

export const validateYouTubeLink = (url: string): boolean => {
  return !url || /^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/.test(url)
}

export const validateSanitizedHTML = (content: string): boolean => {
  return /<[^>]*>/g.test(content)
}

export const sanitizeUrl = (link: string) => {
  try {
    // Attempt to create a new URL object to validate the link
    new URL(link)
    return link // If successful, return the original link
  } catch (e) {
    return '/' // If invalid, return a default safe URL (like homepage or some other fallback)
  }
}

export const allowEmptyOrSpecialChars = (value: string): boolean => {
  return value === '' || /^[a-zA-Z0-9_ !@#$%^&*()\[\]{};:'",.<>?\\|\/\-+=]+$/.test(value)
}

export const validateSelect = (value: string): boolean => {
  return value !== 'Select Year' && value !== 'Select Company' && value !== 'Select Quarter'
}

export const downloadPDF = async (pdfPath: string) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  // Fetch the PDF as a blob to force custom filename
  const response = await fetch(pdfPath)
  const blob = await response.blob()

  // Create object URL from blob
  const url = window.URL.createObjectURL(blob)

  // Create download link
  const link = document.createElement('a')
  link.href = url
  link.download = 'brochure.pdf'
  link.style.display = 'none'

  // Trigger download
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  // Clean up object URL
  window.URL.revokeObjectURL(url)
}

export const validateName = (value: string) => {
  if (value.trim() === '') {
    return 'Name is required'
  } else if (!/^[A-Za-z .]*$/.test(value)) {
    return 'Name can only contain alphabets, spaces, and dot characters'
  } else {
    return ''
  }
}

export const validateContactNumber = (value: string) => {
  if (!/^[6-9]/.test(value)) {
    return 'Contact Number should start with 6, 7, 8, or 9'
  } else if (!/^\d{10}$/.test(value)) {
    return 'Contact Number should be 10 digits long'
  } else {
    return ''
  }
}

export const validateEmail = (value: string) => {
  if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value) && value !== '') {
    return 'Invalid Email Address'
  } else {
    return ''
  }
}
